import { BreadcrumbDataQuery } from '@lib/ui-components';
import { ResourceQueryService } from '@lib/common-sdk';

export const ProjectBranchBreadcrumbProvider: BreadcrumbDataQuery = {
  fetchFunction(id: string): () => Promise<string> {
    return function () {
      return ResourceQueryService.findOneByField<any>('/api/resource/projectBranchViews', 'projectBranchId', id);
    };
  },

  mapToBreadcrumb(data: any): string {
    return data.companyBranchName;
  },

  query: 'projectBranchViews',
};
